/**
 * Job Status Filter.
 */
export type JobStatusFilterOption = (typeof allJobStatusFilterOptions)[number]

/**
 * All job status filter options.
 *
 * Saved list settings refer to options by position, so only ever append.
 */
export const allJobStatusFilterOptions = [
  'Onboarding',
  'InfoGathering',
  'Unclaimed',
  'InProgress',
  'Current',
  'OnHold',
  'Idle',
  'Closed',
  'Pending',
] as const
